module.exports = __webpack_public_path__ + "img/o3_en.48019bbc.jpg";